import * as variants from './compactProductCard.config'
import { calculateDiscountPercentage, formatPrice } from '../../lib/formatters'
import { LABELS } from '../../lib/labels'
import { PriceDisplay } from '../PriceDisplay'

interface CompactPriceProps {
  price: number
  specialPrice?: number | null
  msrp?: number | null
  priceSuffix?: string
}

/** Compact price: optional row (strikethrough + discount badge, or PRP when there is no discount), then final price. */
export function CompactPrice({ price, specialPrice, msrp, priceSuffix = LABELS.PRICE_SUFFIX }: CompactPriceProps) {
  if (price === 0) return null

  const hasDiscount = specialPrice != null && specialPrice > 0 && specialPrice < price
  const finalPrice = hasDiscount ? (specialPrice) : price
  const discountPct = hasDiscount ? calculateDiscountPercentage(price, finalPrice) : 0

  return (
    <div className={variants.compactProductCardPriceWrapperVariants()}>
      {hasDiscount && (
        <div className={variants.compactProductCardStrikethroughRowVariants()}>
          <span className={variants.compactProductCardStrikethroughVariants()}>
            {formatPrice(price)}
          </span>
          <span className={variants.compactProductCardDiscountBadgeVariants()}>
            {`-${discountPct.toFixed(0)}%`}
          </span>
        </div>
      )}
      {/* PRP takes the strikethrough row's slot: same wrapper and a <span>, not a <p> (the theme gives <p> its own line-height) */}
      {!hasDiscount && msrp != null && msrp > 0 && (
        <div className={variants.compactProductCardStrikethroughRowVariants()}>
          <span className={variants.compactProductCardMsrpVariants()}>
            {LABELS.MSRP_PREFIX} {formatPrice(msrp)}
          </span>
        </div>
      )}
      <p className={variants.compactProductCardFinalPriceVariants()}>
        <PriceDisplay price={finalPrice} size="base" />
        <span className={variants.compactProductCardPriceSuffixVariants()}>
          {priceSuffix}
        </span>
      </p>
    </div>
  )
}
